/**
 * PostHog configuration — single source of truth for client and server.
 *
 * The project token (phc_ prefix) is a PUBLISHABLE key. PostHog designs it
 * to be embedded directly in client-side code; it is not a secret and ends
 * up in the browser bundle either way. We hardcode it here rather than
 * reading NEXT_PUBLIC_* env so analytics works regardless of whether the
 * build environment had the var set — a missing build-time env var was the
 * repeated cause of "PostHog was initialized without a token".
 */

export const POSTHOG_TOKEN = "phc_AyxaPdT6PScxDzW6ZbiCH53veVqoqivFnamECGiB9nXz";

// Managed reverse proxy on our own subdomain. Routes event capture and the
// lazy-loaded posthog-js asset bundles through a first-party domain so ad
// blockers (which blocklist *.i.posthog.com) stop dropping 10-25% of events.
// PostHog hosts the proxy; DNS is a grey-cloud CNAME in Cloudflare.
export const POSTHOG_HOST = "https://e.areaadvertising.com";

// Where the PostHog app itself lives. Set as ui_host so the toolbar and any
// in-app links resolve to the real dashboard, not the proxy domain.
export const POSTHOG_UI_HOST = "https://us.posthog.com";
